import { gql } from '@apollo/client'

export default gql`
  mutation updatePatient($id: Int!, $patient: ProfileInformation!) {
    updatePatient(id: $id, patient: $patient) {
      id
      date_of_birth
      email
      first_name
      last_name
      phone_country_code
      phone_number
      address_state_code
      address_post_code
    }
  }
`
